import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useStore } from '@thd-nucleus/experience-context';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { Shared } from './Shared';

export const SharedContainer = () => {
  const disableSSR = typeof window !== 'undefined' && window.DISABLE_SSR;
  const varnish = !disableSSR;
  const store = useStore({ varnish, online: false });
  const { storeZip, isLocalized } = store;
  const { isCustomerIdentified = false } = useThdCustomer() || {};

  const additionalSearchParams = {};
  if (storeZip) {
    additionalSearchParams.deliveryZip = storeZip;
  }

  const isBrandPricingPolicyCompliant = isLocalized ? isCustomerIdentified : false;

  const defaultVariables = {
    skipInstallServices: true,
    skipKPF: true,
    skipFavoriteCount: true,
    skipSpecificationGroup: false,
    skipSubscribeAndSave: true,
    zipCode: undefined,
    additionalSearchParams,
    isBrandPricingPolicyCompliant
  };
  return (
    <QueryProvider
      defaultVariables={defaultVariables}
      cacheKey="shared-page"
    >
      <Shared />
    </QueryProvider>
  );
};

SharedContainer.propTypes = {
};

SharedContainer.defaultProps = {
};
